var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgAttachment = function SvgAttachment(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#attachment_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.711 15.31s.408-.424 6.872-6.888a1.074 1.074 0 0 0 0-1.53 1.072 1.072 0 0 0-1.51 0l-6.889 6.892a3.242 3.242 0 1 0 4.58 4.59l9.16-9.17a5.398 5.398 0 0 0-7.633-7.634l-9.618 9.618-.02.02A7.528 7.528 0 0 0 14.3 21.852l.017-.02 5.806-5.796a1.068 1.068 0 0 0 0-1.517 1.076 1.076 0 0 0-1.517 0l-5.816 5.786-.02.02a5.37 5.37 0 1 1-7.59-7.59l.02-.02 9.618-9.618a3.241 3.241 0 0 1 4.58 4.587l-9.16 9.15a1.08 1.08 0 1 1-1.527-1.523Z",
    fill: "#ACACAC"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "attachment_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
};
export default SvgAttachment;